'use es6';

import ReferenceRecord from 'reference-resolvers/schema/ReferenceRecord';
import IconRecord from 'reference-resolvers/schema/IconRecord';
import { List } from 'immutable';
import indexBy from 'transmute/indexBy';
import get from 'transmute/get';
const SLACK_NAME_BLOCKLIST = ['@hubspot', '@hubspot_qa'];
const formatSlackUserReference = user => new ReferenceRecord({
  id: user.id,
  label: user.real_name,
  // For Slack handle, prefer the `profile` object's `display_name`, if that is missing, please fall back to the `name`
  // See: https://git.hubteam.com/HubSpot/slack-integration/issues/551#issuecomment-950756
  description: user.profile.display_name && `@${user.profile.display_name}` || user.name && `@${user.name}` || '',
  referencedObject: user,
  icon: IconRecord({
    type: 'image',
    src: user.profile.image_48 || ''
  })
});
export const formatSlackUsers = response => List(response.map(formatSlackUserReference).filter(user => !SLACK_NAME_BLOCKLIST.includes(user.get('description'))));
export const formatSlackUsersMap = response => indexBy(get('id'), formatSlackUsers(response));